import { Twinkle } from "@faire/slate-icons/Twinkle";
import React, { useState } from "react";

const AI_BACKGROUND = "#FDF0FF";
const AI_BORDER = "#E8B8F5";

/**
 * Playground stand-in for brand-portal `AIRecommendationIcon` (purple sparkle + hover tooltip).
 */
export const MockAiSparkleIcon: React.FC<{ tooltipText: string }> = ({
  tooltipText,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <span
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-[border-color] duration-200"
        style={{
          backgroundColor: AI_BACKGROUND,
          borderColor: hovered ? AI_BORDER : AI_BACKGROUND,
        }}
        aria-hidden
      >
        <Twinkle height="12px" width="12px" strokeWidth={1.5} />
      </span>
      <span
        role="tooltip"
        className="type-fs-label pointer-events-none absolute top-1/2 left-full z-50 ml-2 -translate-y-1/2 rounded border px-2 py-1 whitespace-nowrap shadow-sm transition-opacity duration-200"
        style={{
          backgroundColor: AI_BACKGROUND,
          borderColor: AI_BORDER,
          color: "var(--slate-color-text-primary)",
          opacity: hovered ? 1 : 0,
          visibility: hovered ? "visible" : "hidden",
        }}
      >
        {tooltipText}
      </span>
    </span>
  );
};
